import React, { useState } from 'react';

const VideoPlayer = ({ title, link }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  // Validate YouTube embed URL
  const isValidYouTubeUrl = (url) => {
    const pattern = /^https?:\/\/(www\.)?youtube\.com\/embed\/[A-Za-z0-9_-]{11}$/;
    return pattern.test(url);
  };

  if (!link || !isValidYouTubeUrl(link)) {
    return (
      <div className="aspect-video bg-gray-800/50 rounded-lg flex items-center justify-center border-2 border-dashed border-gray-600">
        <div className="text-center text-gray-400">
          <div className="text-4xl mb-2">⚠️</div>
          <p className="text-sm">Invalid video URL</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative group">
      <div className="aspect-video bg-gray-900 rounded-lg overflow-hidden shadow-lg">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-800">
            <div className="text-center">
              <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mb-3"></div>
              <p className="text-gray-300 text-sm">Loading video...</p>
            </div>
          </div>
        )}
        
        {hasError ? (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-800">
            <div className="text-center text-gray-400">
              <div className="text-4xl mb-3">📹</div>
              <p className="text-sm mb-2">Failed to load video</p>
              <button 
                onClick={() => {
                  setHasError(false);
                  setIsLoading(true);
                }}
                className="text-purple-400 hover:text-purple-300 text-xs underline"
              >
                Try again
              </button>
            </div>
          </div>
        ) : (
          <iframe
            className="w-full h-full"
            src={link}
            title={title || "Video"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            onLoad={handleLoad}
            onError={handleError}
            loading="lazy"
          />
        )}
      </div>
      
      {/* Overlay with title on hover */}
      <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-lg flex items-center justify-center pointer-events-none">
        <div className="text-center text-white p-4">
          <h4 className="font-medium text-sm line-clamp-2">{title}</h4>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;
